<template>
  <div class="min-h-screen bg-slate-50" aria-busy="true" aria-label="Loading contractor page">
    <header class="border-b border-slate-100 bg-white">
      <nav class="mx-auto flex h-[56px] w-[calc(100%-32px)] max-w-[1272px] items-center justify-between gap-[24px] sm:w-[calc(100%-48px)]">
        <span class="text-[18px] font-bold tracking-tight text-slate-900">SCREENED</span>
        <div class="hidden items-center gap-[32px] md:flex">
          <span class="text-[14px] text-slate-500">Dashboard</span>
          <span class="text-[14px] font-medium text-teal-700">Job Search</span>
          <span class="text-[14px] text-slate-500">Search Companies</span>
        </div>
        <div class="flex items-center gap-2">
          <span class="h-[32px] w-[32px] animate-pulse rounded-full bg-teal-50"></span>
          <span class="hidden h-3 w-16 animate-pulse rounded bg-slate-100 sm:block"></span>
        </div>
      </nav>
    </header>

    <main class="mx-auto w-[calc(100%-32px)] max-w-[1272px] py-[32px] sm:w-[calc(100%-48px)]">
      <div class="mb-6 h-7 w-52 animate-pulse rounded bg-slate-200"></div>
      <div class="grid gap-5 md:grid-cols-3">
        <div v-for="item in 6" :key="item" class="rounded-xl border border-slate-200 bg-white p-5">
          <div class="flex items-center gap-3">
            <span class="h-10 w-10 animate-pulse rounded-lg bg-teal-50"></span>
            <div class="flex-1 space-y-2">
              <div class="h-3 w-3/4 animate-pulse rounded bg-slate-200"></div>
              <div class="h-2.5 w-1/2 animate-pulse rounded bg-slate-100"></div>
            </div>
          </div>
          <div class="mt-5 h-16 animate-pulse rounded-lg bg-slate-50"></div>
          <div class="mt-4 h-8 w-full animate-pulse rounded-lg bg-teal-50"></div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { contractorPortal } from '@/config/contractorPortal'

const destinations = {
  jobs: '/contractor/jobs',
  companies: '/contractor/companies',
  'profile-edit': '/contractor/profile/edit',
}

export default {
  name: 'PlatformHandoff',
  created() {
    this.completeHandoff()
  },
  methods: {
    returnToDashboard() {
      window.location.replace(contractorPortal.dashboardUrl || contractorPortal.loginUrl || '/contractor/login')
    },
    async completeHandoff() {
      const fragment = new URLSearchParams(window.location.hash.slice(1))
      const code = fragment.get('code')
      const destination = fragment.get('destination')
      const slug = fragment.get('slug')
      window.history.replaceState(window.history.state, '', window.location.pathname + window.location.search)

      const slugDestination = destination === 'company' || destination === 'job'
      const knownDestination = Object.prototype.hasOwnProperty.call(destinations, destination) || slugDestination
      const validSlug = !slugDestination || /^[A-Za-z0-9_-]{1,160}$/.test(slug || '')
      if (!contractorPortal.enabled || !code || !knownDestination || !validSlug) {
        this.returnToDashboard()
        return
      }

      try {
        const response = await fetch(`${process.env.VUE_APP_API_BASEURL}/contractor/platform-handoff`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ code }),
          cache: 'no-store',
        })
        const result = await response.json()
        if (!response.ok || !result.token || !result.name) throw new Error('Exchange failed')

        localStorage.setItem('contractorToken', result.token)
        localStorage.setItem('contractorName', result.name)
        localStorage.removeItem('companyToken')
        sessionStorage.removeItem('contractorReadyStatus')
        sessionStorage.removeItem('contractorReadyStatusAt')
        sessionStorage.removeItem('contractorCompanySearchAccess')
        sessionStorage.removeItem('contractorCompanySearchAccessAt')
        this.$store.commit('setContractorLoggedIn', true)
        this.$store.commit('setContractorName', result.name)
        this.$router.replace(destination === 'company'
          ? `/contractor/company/${encodeURIComponent(slug)}`
          : destination === 'job'
            ? `/contractor/job/${encodeURIComponent(slug)}`
            : destinations[destination])
      } catch (error) {
        this.returnToDashboard()
      }
    },
  },
}
</script>
